var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTimeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#20ABAD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_13898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6545 10.4064C16.3731 11.0993 16.7367 11.6098 17.221 12.1952C18.468 13.7023 18.1711 15.9245 16.6597 17.1745C15.1705 18.4053 12.9801 18.243 11.6761 16.7959C11.5258 16.6292 11.4043 16.5499 11.154 16.5832C7.34637 17.0849 3.99039 14.1291 4.00002 10.296C4.00817 6.98388 6.55551 4.28673 9.92851 4.01849C13.0786 3.76804 16.0014 6.08952 16.5294 9.26831C16.5879 9.61879 16.6086 9.9752 16.6545 10.4064ZM11.628 14.3781C11.6332 15.8941 12.8698 17.1234 14.3767 17.1108C15.8659 17.0982 17.0914 15.8682 17.0996 14.3781C17.1077 12.8702 15.8681 11.6291 14.3604 11.6365C12.8335 11.6439 11.6228 12.8583 11.628 14.3781ZM9.93443 6.317C9.93443 7.5574 9.93443 8.75481 9.93443 9.99076C9.1184 9.99076 8.33864 9.99076 7.55593 9.99076C7.55593 10.3042 7.55593 10.5776 7.55593 10.8399C8.65706 10.8399 9.73005 10.8399 10.809 10.8399C10.809 9.31944 10.809 7.82859 10.809 6.317C10.5224 6.317 10.2588 6.317 9.93443 6.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9473 12.4922C14.2353 12.4922 14.4997 12.4922 14.7863 12.4922C14.7863 13.3947 14.7863 14.2816 14.7863 15.2027C14.5108 15.2027 14.2405 15.2027 13.9473 15.2027C13.9473 14.3083 13.9473 13.4199 13.9473 12.4922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9424 16.3898C13.9424 16.1653 13.9424 15.9645 13.9424 15.7422C14.229 15.7422 14.5007 15.7422 14.7895 15.7422C14.7895 15.9637 14.7895 16.1638 14.7895 16.3898C14.5081 16.3898 14.2467 16.3898 13.9424 16.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_13898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimeActive);
export default __webpack_public_path__ + "static/media/ic_time_active.0105c2d057916111756067f4548dad19.svg";
export { ForwardRef as ReactComponent };